function About() {
  return (
    <>
      <section class="py-8 d-flex align-items-center bg-auto bg-image-2">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12">
              <div className="z-2 position-relative">
                <h1 class="mb-2 display-5 ls-sm text-white fw-bold">
                  <span>Albedo Institute, Ranchi</span>
                </h1>
                <ol class="breadcrumb">
                  <li class="breadcrumb-item fs-5">
                    <a href="#">Home</a>
                  </li>
                  <li
                    class="breadcrumb-item active fs-5 text-white"
                    aria-current="page"
                  >
                    About Us
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mt-5 mb-6">
        <div className="container">
          <h2 class="fw-bold mb-2">
            <u class="text-primary">
              <span class="text-dark">About Us</span>
            </u>
          </h2>
          <p className="fs-4 lh-sm text-dark">
            Albedo Institute is a part of Albinstitute Pvt. Ltd, is a premier
            educational institution based in Ranchi, Jharkhand. The institution
            has a clear vision that inspires in-depth educational interventions
            for students as they navigate key transitions in their academic
            careers, whether to an engineering-focused education or to preparing
            for competitive school-level exams.
            <br />
            <br />
            Founded by a group of passionately-involved educators, Albedo
            Institute committed to transforming learning into an enjoyable and
            enriching experience. This institute holds the belief that education
            is not just about studying but about self-exploration and personal
            development. Their mission is to inspire students to embrace
            knowledge with curiosity and enthusiasm.
            <br />
            <br />
            By providing a supportive learning environment, expert guidance, and
            relevant study materials, Albedo Institute builds student confidence
            in their academic abilities. Their aim is to ensure quality
            education accessible and meaningful for every learner.
          </p>

          <h2 class="fw-bold mb-2">
            Our{" "}
            <u class="text-primary">
              <span class="text-dark">Mission</span>
            </u>
          </h2>
          <p className="fs-4 lh-sm text-dark">
            Our mission is to make learning meaningful, accessible, and
            future-ready by providing structured education, expert guidance, and
            a supportive learning environment that empowers students to achieve
            academic success.
          </p>

          <h2 class="fw-bold mb-2">
            Our{" "}
            <u class="text-primary">
              <span class="text-dark">Vision</span>
            </u>
          </h2>
          <p className="fs-4 lh-sm text-danger mb-3">
            To become a trusted center of educational excellence where students
            are nurtured into confident learners, critical thinkers, and
            responsible individuals prepared for future challenges.
          </p>

          <h2 class="fw-bold mb-2">
            Our{" "}
            <u class="text-primary">
              <span class="text-dark">Approach</span>
            </u>
          </h2>
          <p className="fs-4 lh-sm text-dark">
            Albedo Institute follows a student-centric teaching methodology that
            emphasizes:
            <ul>
              <li>Concept-based learning over rote memorization</li>
              <li>Personalized academic support and mentorship</li>
              <li>Regular assessment and constructive feedback</li>
              <li>Discipline, consistency, and academic clarity</li>
            </ul>
            Our programs are designed to adapt to different learning styles and
            academic goals, ensuring every student receives the guidance they
            need to grow.
          </p>
          <h2 class="fw-bold mb-2">
            Our{" "}
            <u class="text-primary">
              <span class="text-dark">Faculty</span>
            </u>
          </h2>
          <p className="fs-4 lh-sm text-dark">
            Our educators are experienced, dedicated, and deeply committed to
            student success. Beyond teaching, they mentor students, motivate
            them during challenges, and help them build confidence and
            discipline throughout their academic journey.
          </p>
        </div>
      </section>
    </>
  );
}

export default About;
